import {Field} from 'formik';

import {
    FormikNumberInput,
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Stack} from '@mantine/core';


export const FormComponent = () => {

    return (
        <Stack gap={'xl'}>
            <PlatformFieldset legend={'Phase Details'}>
                {/* playbookId is seeded from the parent route and submitted via initialValues; no visible input. */}
                <Field type={'hidden'} name='playbookId'/>

                <Field
                    name='name'
                    label='Name'
                    description='Machine-readable identifier (e.g. "provision-infrastructure")'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='displayName'
                    label='Display Name'
                    description='Human-friendly name shown in the UI'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='description'
                    label='Description'
                    description='What this phase does'
                    component={FormikTextarea}
                    my={'xl'}
                />

                <Field
                    name='position'
                    label='Position'
                    description='Ordering of this phase within the playbook (lower values appear first)'
                    component={FormikNumberInput}
                    withAsterisk
                    my={'xl'}
                />
            </PlatformFieldset>
        </Stack>
    );
};
